let allImages = []; // Toutes les images restantes à loader
let observer; // L'observer pour les images
let domObserver; // l'observer pour les changements au document (ajout, suppression, etc.)
let dynamicWidthImages = []; // Toutes les images dont la largeur est surveillé.
let running = false; // Empêche l'exécution double du resize.
let currentlyAnimating = []; // Tous les images qui sont actuellement resizer.

const config = {
    // On télécharge les images qui sont 200px en haut jusqu'à 200px en bas du viewport.
    rootMargin: '200px 0px',
    threshold: 0.01
};

const domConfig = {
    childList: true,
    subtree: true,
    attributes: true
};

/**
 * Retourne si le browser supporte l'intersection Observer.
 * 
 * @return {Bool}
 */
function check_intersectionObserver_support(){
    return (('Promise' in window) && ('IntersectionObserver' in window));
}


// Check the support for intersection observer.
if(check_intersectionObserver_support()){
    // It is supported, initialize it.
    observer = new IntersectionObserver(onIntersection, config);

}


// Quand le document est prêt, on active le mutateur du DOM.
(function(){
    initLazyLoad(document);
    domObserver = new MutationObserver(domChanged);
    domObserver.observe(document, domConfig);
})();


/**
 * Prépare le lazyload sur tous les images contenu dans le sélecteur.
 * 
 * @param {Node} selector 
 */
function initLazyLoad(selector){
    // Get all of the images
    if(typeof selector.querySelectorAll !== 'undefined'){
        const images = selector.querySelectorAll('.js-lazy-image');

        if(images.length){
            // If we don't have support for intersection observer, load the images immediately
            if(!check_intersectionObserver_support()){
                loadImagesImmediately(images);

            }else{
                for (let i = 0; i < images.length; i++) { 
                    let image = images[i];
                    if (allImages.indexOf(image) >= 0 || image.classList.contains('js-lazy-image--handled')) {
                        continue;
                    }
                    
                    allImages.push(image);
                    observer.observe(image);
                }
            }
        }
    }
}


/**
 * Est appelé par un mutateur à chaque fois qu'un élément de la page est ajouté/supprimé ou qu'un attribut est modifié.
 * Ceci permet d'avoir le lazyload fonctionnel avec toutes les modifications sur le DOM.
 * 
 * @param {Object} mutations 
 */
function domChanged(mutations){
    mutations.forEach(function(mutation){
        if(mutation.type == 'childList'){
            let addedNodes = mutation.addedNodes;
            let removedNodes = mutation.removedNodes;
            
            if(addedNodes.length){ // Nouveau contenu ajouté
                for(let i = 0; i < addedNodes.length; i++){
                    initLazyLoad(addedNodes[i]);
                }
            }

            if(removedNodes.length && check_intersectionObserver_support()){ // Contenu supprimé
                for(let i = 0; i < removedNodes.length; i++){
                    if(typeof removedNodes[i].querySelectorAll !== 'undefined'){
                        const images = removedNodes[i].querySelectorAll('.js-lazy-image');

                        for (let i = 0; i < images.length; i++) { 
                            let image = images[i];
                            
                            for(let key in allImages){ // retire l'image du tableau
                                if(allImages[key] == image){
                                    allImages.splice(key, 1);
                                }
                            }

                            observer.unobserve(image);
                        }
                    }
                }
            }
        }else if(mutation.type == 'attributes' && !running && dynamicWidthImages.length && mutation.target.tagName != 'SOURCE'){
            running = true;
            requestAnimationFrame(function() {
                for(let i = 0; i < dynamicWidthImages.length; i++){
                    changeImageSize(dynamicWidthImages[i]);
                };
                running = false;
            });
        }
	}); 
}



/**
 * Fetchs the image for the given URL
 * @param {string} url 
 */
function fetchImage(url) {
    return new Promise((resolve, reject) => {
        const image = new Image();

        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
    });
}


/**
 * Preload l'image. Si celle-ci est dans un picture, on preload l'image approprié de la bonne source.
 * @param {object} image 
 */
function preloadImage(image) {
    const src = image.dataset.src;
    const type = image.tagName.toLowerCase();
    const img_parent = image.parentElement;
    let prefetch_url = '';

    if(img_parent.nodeName == 'PICTURE'){
        const current_source = get_source_from_width(img_parent.getElementsByTagName('source'), img_parent.offsetWidth);

        if(current_source){
            prefetch_url = current_source.getAttribute('srcset');
        }

    }else if(image.dataset.srcset){
        prefetch_url = get_srcset_current_from_width(image.dataset.srcset, img_parent.offsetWidth);
    }
    
    if(prefetch_url == ''){
        prefetch_url = src;
    }

    if (!src) {
        return;
    }
    
    if(type == 'iframe'){
        return applyImage(image, src);

    }else{
        return fetchImage(prefetch_url).then(() => { applyImage(image, src); });
    }
}


/**
 * 
 * @param {*} srcset 
 * @param {*} width 
 */
function get_srcset_current_from_width(srcset, width){
    srcset = srcset.split(", ");
    let srcsetLength = srcset.length;
    let currentSrcset = null;
    let src = '';

    for(let i = 0; i < srcsetLength; i++){
        let srcsetData = srcset[i].split(" ");
        
        // Si la largeur du src est supérieur à la largeur demandé
        if(parseInt(srcsetData[1]) >= width){
            // On a déjà une largeur, on regarde laquelle est la plus petite
            if(currentSrcset != null){
                if(parseInt(srcsetData[1]) < parseInt(currentSrcset[1])){
                    currentSrcset = srcsetData;
                }

            }else{
                currentSrcset = srcsetData;
            }
        }
    }

    if(currentSrcset != null){
        src = currentSrcset[0];
    }

    return src;
}


/**
 * Load all of the images immediately
 * @param {NodeListOf<Element>} images 
 */
function loadImagesImmediately(images) {
    for (let i = 0; i < images.length; i++) { 
        let image = images[i];
        const src = image.dataset.src;

        applyImage(image, src);
    }
}


/**
 * Disconnect the observer
 */
function disconnect() {
    if (!observer) {
        return;
    }
  
    observer.disconnect();
}


function onIntersection(entries) {
    // Disconnect if we've already loaded all of the images
    if (allImages.length === 0) {
        observer.disconnect();
    }

	// Loop through the entries
	for (let i = 0; i < entries.length; i++) {
        let entry = entries[i];
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
            for(let key in allImages){ // retire l'image du tableau
                if(allImages[key] == entry.target){
                    allImages.splice(key, 1);
                }
            }

            // Stop watching and load the image
            observer.unobserve(entry.target);
            if(entry.target.nodeName == 'IMG' || entry.target.nodeName == 'IFRAME'){
                preloadImage(entry.target);

            }else{
                entry.target.classList.remove('js-lazy-image');
            }
        }
    }
}


/**
 * Apply the image
 * @param {object} img 
 * @param {string} src 
 */
function applyImage(img, src) {
    const srcset = img.dataset.srcset;
    const sizes = img.dataset.sizes;
    
    if(sizes == 'auto'){
        addImageWidthListener(img);
    }

    if(srcset){
        img.srcset = srcset;
        img.removeAttribute('data-srcset');
    }
    
    img.src = src;
    
    // Prevent this from being lazy loaded a second time.
    img.classList.remove('js-lazy-image');
    img.classList.add('js-lazy-image--handled');
    img.removeAttribute('data-src');
    img.removeAttribute('data-sizes');

    img.dispatchEvent(new CustomEvent('lazyloaded'));
}


/**
 * Ajoute tous les listener, mutateur requis pour que l'attribut size de l'image corresponde à la largeur réel de l'image.
 * 
 * @param {Node} img 
 */
function addImageWidthListener(img){
    dynamicWidthImages.push(img); // Ajoute l'image dans le tableau pour le resize.
    changeImageSize(img);

    // ajoute un mutateur pour changer le width de l'image lorsqu'une attribut est changé.
    const sizeConfig = {
        attributes: true
    };
    let attrObserver = new MutationObserver(watchAttrChange);

    attrObserver.observe(img, sizeConfig);

    // Ajoute un listener sur l'image pour que à chaque début de trasition de width, on change la valeur pour représenter celle animé.
    img.addEventListener('transitionstart', function(transition){
        changeImageSize(transition.target);
    });

    // à la fin de la transition, on update la valeur du width.
    img.addEventListener('transitionend webkitTransitionEnd oTransitionEnd', function(transition){
        changeImageSize(transition.target);
    });
}


/**
 * Callback pour le mutateur des images à largeur variable.
 * Lorsqu'un attribut sur une image change, on vérifie sa largeur.
 * 
 * @param {Object} mutations 
 */
function watchAttrChange(mutations){
    mutations.forEach(function(mutation) {
        if(mutation.type == 'attributes'){
           changeImageSize(mutation.target);
        }
    });
}


/**
 * Change la l'attribut sizes de l'image seulement si celle-ci à changé.
 * 
 * @param {Node} img
 */
function changeImageSize(img, checkupCall){
    if(currentlyAnimating.indexOf(img) >= 0){
        return false;
    }
    
    let parent = img.parentElement;
    let currentSource = null;
    let sources;
    let sourcesLength = 0;

    let newImageWidth = parent.offsetWidth;
    checkupCall = (typeof checkupCall === 'undefined') ? false : checkupCall;
    
    if(newImageWidth != parseInt(img.sizes)){ // La largeur à changé
        currentlyAnimating.push(img);

        if(parent.nodeName == 'PICTURE'){
            sources = parent.getElementsByTagName('source');
            sourcesLength = sources.length;

            currentSource = get_source_from_width(sources, newImageWidth);

            // Reset le media des autres sources.
            for(let k = 0; k < sourcesLength; k++){
                if(sources[k] != currentSource){
                    sources[k].media = "(max-width: 0px)";
                }
            }
        }

        requestAnimationFrame(function() {
            img.sizes = newImageWidth+'px';

            setTimeout(function(){
                for(let key in currentlyAnimating){
                    if(currentlyAnimating[key] == img){
                        currentlyAnimating.splice(key, 1);
                    }
                }
            }, 100);
        });

    }else if(!checkupCall){
        setTimeout(function(){
            changeImageSize(img, true);
        }, 200);
    }

    // Cherche la source actuellement active.
    if(sourcesLength > 0 && !currentSource){
        for(let index in sources){
            if(sources[index].media != '(max-width: 0px)'){
                currentSource = sources[index];
                break;
            }
        }
    }

    if(currentSource){ // Doit toujours correspondre avec la largeur de la page.
        currentSource.media = "(max-width: "+window.innerWidth+"px)";
    }
}


/**
 * Trouve la source approprié selon la largeur fourni et la retourne.
 * 
 * @param {HTMLCollection} sources
 * @param {Int} width
 * @return {Mixed} False si aucune source n'est trouvé, sinon l'élément source.
 */
function get_source_from_width(sources, width){
    const sourcesLength = sources.length;

    if(sourcesLength > 0){
        for(let i = 0; i < sourcesLength; i++){
            var sourceWidth = parseInt(sources[i].getAttribute('sizes'));

            // La largeur de la source est supérieur à la largeur actuel.
            if(sourceWidth >= width){
                return sources[i];
            }
        }
    }

    return false;
}


/**
 * Ajoute un listener sur notre event custom qui change l'attribut sizes de toutes les images
 * qui ont une largeur variable.
 */
window.addEventListener("optimizedResize", function() {
    if(dynamicWidthImages.length){
        for(let i = 0; i < dynamicWidthImages.length; i++){
            changeImageSize(dynamicWidthImages[i]);
        }
    }
});


/**
 * Ajoute un event identique à resize, mais qui demande moins de ressources. 
 */
(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
             requestAnimationFrame(function() {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    throttle("resize", "optimizedResize");
})();